import { FormattedMessage } from 'react-intl';
// import { } from ""
import {
  frontdeskSubMenus,
  reservationsSubMenus,
  houseKeepingNavlinks,
  settingsSubMenus,
  backTrackSubMenus,
  recordsSidebarNavlinks,
  mainBarSubMenus,
  poolBarSubMenus,
  restaurantSubMenus,
  storeSubMenus,
  statisticsSubMenus,
  accountsSubMenus
} from './SidebarNavLinks';

const sidebarMenuHelper = (subMenu: any): any[] => {
  const moduleChildren = [] as any[];
  const { moduleName, subModules } = subMenu;
  Object.keys(subModules).forEach((subModule, index) => {
    const subModuleChildren = [] as any[];
    const subModuleData = subModules[subModule] as string[];
    const generalRouteProps = {
      id: subModule.toLowerCase(),
      title: <FormattedMessage id={subModule} />,
      type: subModuleData.length ? 'collapse' : 'item',
      breadcrumbs: subModuleData.length ? true : false
    };
    if (subModuleData.length) {
      subModuleData.forEach((mod) => {
        const data = {
          id: mod.toLowerCase(),
          title: <FormattedMessage id={mod} />,
          type: 'item',
          url: `/${moduleName.toLowerCase().replaceAll(' ', '-')}/${subModule.toLowerCase().replaceAll(' ', '-')}/${mod
            .toLowerCase()
            .replaceAll(' ', '-')}`
        };
        subModuleChildren.push(data);
      });
      const data2 = {
        ...generalRouteProps,
        children: subModuleChildren
      };
      moduleChildren.push(data2);
    } else {
      const data = {
        ...generalRouteProps,
        url: `/${moduleName.toLowerCase().replaceAll(' ', '-')}/${subModule.toLowerCase().replaceAll(' ', '-')}`
      };
      moduleChildren.push(data);
    }
  });
  return moduleChildren;
};
export const reservationsSubModule = sidebarMenuHelper(reservationsSubMenus);
export const frontdeskSubModule = sidebarMenuHelper(frontdeskSubMenus);
export const housekeepingSubModule = sidebarMenuHelper(houseKeepingNavlinks);
export const settingsSubModule = sidebarMenuHelper(settingsSubMenus);
export const backTrackSubModule = sidebarMenuHelper(backTrackSubMenus);
export const recordsSubModule = sidebarMenuHelper(recordsSidebarNavlinks);
export const mainBarSubModule = sidebarMenuHelper(mainBarSubMenus);
export const poolBarSubModule = sidebarMenuHelper(poolBarSubMenus);
export const restaturantSubModule = sidebarMenuHelper(restaurantSubMenus);

export const storeSubModule = sidebarMenuHelper(storeSubMenus);
export const accountsSubModule = sidebarMenuHelper(accountsSubMenus);
export const statisticsSubModule = sidebarMenuHelper(statisticsSubMenus);
